import { DateRangeType } from '../../common/components/DateRangeTypePicker';

export type EVSEToken = {
  token: string;
};

export type WifiData = {
  ssid: string;
  password: string;
};

export type WifiListNetwork = {
  signalStrength: number;
  ssid: string;
};

export type QRCodeValues = { sn: string; cpid: string; wifi: WifiData | null };

// SmartPlug ships with a NEMA 14-50 power cord + plug instead of being hard-wired.
export type EvseType = 'SmartAmp' | 'SmartPlug';

// Response of the local (Soft-AP) EVSE API `GET /evse/v1/productinformation`.
export type EvseProductInformation = {
  // Same format as the model number, e.g. `EVRBA40ANAMJ1772` (older FW reports a marketing name).
  CommercialReference: string;
  ExternalMeterDetection: boolean;
  FirmwareVersion: string;
  Phasesnumber: string;
  SerialNumber: string;
  TICdetection: boolean;
};

export type ChargerConfiguration = {
  imgSrc: {
    light: string;
    dark: string;
  };
};

export type Schedule = {
  groupId: string | null;
  name: string | null;
  daysOfWeek: number[];
  startTime: string | null;
  endTime: string | null;
  isEditing: boolean;
};

export const AggregationType = {
  ...DateRangeType,
  Session: 'SESSION',
} as const;

export type AggregationType = (typeof AggregationType)[keyof typeof AggregationType];

export type ChargingActivityData = {
  totalCost: string;
  totalChargeTime: string;
  totalEnergyConsumed: string;
  savings: number;
  chargingSessions: ChargingActivitySessionData[];
};

export type ChargingActivitySessionData = {
  id: number;
  weeks?: number;
  start: string;
  end: string;
  cost: number;
  usage: number;
  records: ChargingActivityRecordsRawData[];
};

export type ChargingActivityRawData = {
  agg_type: AggregationType;
  total_energy: number;
  total_charge_count: number;
  total_charge_duration: number;
  total_cost: number;
  smart_control_savings: number;
  records: ChargingActivityRecordsRawData[];
};

export type ChargingActivityRecordsRawData = {
  charge_count?: number;
  start: string;
  end: string;
  total_charge_duration?: number;
  usage: number;
  total_cost?: number;
  cost?: number;
  records?: ChargingActivityRecordsRawData[];
};

/**
 * Granular OCPP-level firmware update steps (`firmwareStatus` field) received
 * from the Clipsal Cloud `FirmwareUpdateStatus` SSE event.
 */
export type FirmwareUpdateStatus =
  | 'Downloading'
  | 'Downloaded'
  | 'Installing'
  | 'Installed'
  | 'DownloadFailed'
  | 'InstallationFailed';

/**
 * High-level aggregate firmware status (`cloudFirmwareStatus` field) received
 * from the Clipsal Cloud `FirmwareUpdateStatus` SSE event.
 * This is the field the app uses to drive top-level UI gating (pending).
 */
export type CloudFirmwareStatus = 'Pending' | 'InProgress' | 'Success' | 'Failed' | 'FailedChargerNotConnected';
